<p-toast />
<div class="training-batch-container mt-6">
  <div class="flex justify-content-between mb-4 align-items-center">
    <p class="text-xl font-semibold">{{ 'layout.configurations.training_batch.main_title' | translate }}</p>
  </div>

  <!-- Manual Trigger Card -->
  <div class="batch-card p-4 border-1 border-300 border-round surface-card mb-4">
    <div class="flex align-items-start gap-3">
      <div class="batch-icon-wrap">
        <i class="pi pi-cloud-download batch-icon"></i>
      </div>
      <div class="flex-1">
        <p class="text-lg font-semibold m-0 mb-2">{{ 'layout.configurations.training_batch.run_title' | translate }}</p>
        <p class="text-sm text-color-secondary m-0 mb-3">
          {{ 'layout.configurations.training_batch.run_desc_prefix' | translate }}
          <!-- i18n-ignore: storage paths / file extensions -->
          <code class="code-tag">training-import/pending/</code>
          {{ 'layout.configurations.training_batch.run_desc_middle' | translate }}
          <!-- i18n-ignore: storage paths / file extensions -->
          <code class="code-tag">.xlsx</code>
          {{ 'layout.configurations.training_batch.run_desc_suffix' | translate }}
        </p>
        <div class="batch-info-row">
          <div class="info-chip">
            <i class="pi pi-clock"></i>
            <span>{{ 'layout.configurations.training_batch.scheduled' | translate }}</span>
          </div>
          <div class="info-chip">
            <i class="pi pi-folder"></i>
            <!-- i18n-ignore: storage paths / file extensions -->
            <span>{{ 'layout.configurations.training_batch.pending' | translate }}: <code>training-import/pending/</code></span>
          </div>
          <div class="info-chip">
            <i class="pi pi-box"></i>
            <!-- i18n-ignore: storage paths / file extensions -->
            <span>{{ 'layout.configurations.training_batch.archive' | translate }}: <code>training-import/archive/</code></span>
          </div>
        </div>
      </div>
    </div>
    <div class="batch-action-bar mt-3 pt-3 border-top-1 border-200">
      <div class="flex align-items-center justify-content-between">
        <p class="text-xs text-color-secondary m-0">
          <i class="pi pi-info-circle mr-1"></i>
          {{ 'layout.configurations.training_batch.fail_info_prefix' | translate }}
          <!-- i18n-ignore: storage paths / file extensions -->
          <code>archive/failed/</code>
          {{ 'layout.configurations.training_batch.fail_info_suffix' | translate }}
        </p>
        <p-button
          icon="pi pi-play"
          [label]="'layout.configurations.training_batch.btn_run' | translate"
          [loading]="trainingBatchLoading"
          [disabled]="trainingBatchLoading"
          (onClick)="triggerTrainingBatch()"
          styleClass="p-button-outlined">
        </p-button>
      </div>
    </div>
  </div>
<!-- Pool Batch Manual Trigger -->
<div class="batch-card p-4 border-1 border-300 border-round surface-card mb-4">
  <div class="flex align-items-start gap-3">
    <div class="batch-icon-wrap">
      <i class="pi pi-users batch-icon"></i>
    </div>

    <div class="flex-1">
      <p class="text-lg font-semibold m-0 mb-2">
        {{ 'layout.configurations.training_batch.pool_batch.title' | translate }}
      </p>

      <p class="text-sm text-color-secondary m-0 mb-3">
        {{ 'layout.configurations.training_batch.pool_batch.description' | translate }}
      </p>

      <div class="batch-info-row">
        <div class="info-chip">
          <i class="pi pi-clock"></i>
          <span>
            {{ 'layout.configurations.training_batch.pool_batch.scheduled' | translate }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="batch-action-bar mt-3 pt-3 border-top-1 border-200">
    <div class="flex align-items-center justify-content-end">
      <p-button
        icon="pi pi-play"
        [label]="'layout.configurations.training_batch.pool_batch.btn_run' | translate"
        [loading]="poolBatchLoading"
        [disabled]="poolBatchLoading"
        (onClick)="triggerPoolBatch()"
        styleClass="p-button-outlined">
      </p-button>
    </div>
  </div>
</div>
<!-- Evaluation Batch Manual Trigger -->
<div class="batch-card p-4 border-1 border-300 border-round surface-card mb-4">
  <div class="flex align-items-start gap-3">
    <div class="batch-icon-wrap">
      <i class="pi pi-check-square batch-icon"></i>
    </div>

    <div class="flex-1">
      <p class="text-lg font-semibold m-0 mb-2">
        {{ 'layout.configurations.training_batch.evaluation_batch.title' | translate }}
      </p>

      <p class="text-sm text-color-secondary m-0 mb-3">
        {{ 'layout.configurations.training_batch.evaluation_batch.description' | translate }}
      </p>

      <div class="batch-info-row">
        <div class="info-chip">
          <i class="pi pi-clock"></i>
          <span>
            {{ 'layout.configurations.training_batch.evaluation_batch.scheduled' | translate }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="batch-action-bar mt-3 pt-3 border-top-1 border-200">
    <div class="flex align-items-center justify-content-end">
      <p-button
        icon="pi pi-play"
        [label]="'layout.configurations.training_batch.evaluation_batch.btn_run' | translate"
        [loading]="evaluationBatchLoading"
        [disabled]="evaluationBatchLoading"
        (onClick)="triggerEvaluationBatch()"
        styleClass="p-button-outlined">
      </p-button>
    </div>
  </div>
</div>
<!-- Database Backup Manual Trigger -->
<div class="batch-card p-4 border-1 border-300 border-round surface-card mb-4">
  <div class="flex align-items-start gap-3">
    <div class="batch-icon-wrap">
      <i class="pi pi-database batch-icon"></i>
    </div>

    <div class="flex-1">
      <p class="text-lg font-semibold m-0 mb-2">
        {{ 'layout.configurations.database_backup.title' | translate }}
      </p>

      <p class="text-sm text-color-secondary m-0 mb-3">
        {{ 'layout.configurations.database_backup.description' | translate }}
      </p>

      <div class="batch-info-row">
        <div class="info-chip">
          <i class="pi pi-clock"></i>
          <span>
            {{ 'layout.configurations.database_backup.scheduled' | translate }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="batch-action-bar mt-3 pt-3 border-top-1 border-200">
    <div class="flex align-items-center justify-content-end">
      <p-button
        icon="pi pi-play"
        [label]="'layout.configurations.database_backup.btn_run' | translate"
        [loading]="backupLoading"
        [disabled]="backupLoading"
        (onClick)="triggerDatabaseBackup()"
        styleClass="p-button-outlined">
      </p-button>
    </div>
  </div>
</div>
  <!-- How It Works -->
  <div class="batch-card p-4 border-1 border-300 border-round surface-card">
    <p class="text-base font-semibold m-0 mb-3">
      <i class="pi pi-question-circle mr-2 text-primary"></i>{{ 'layout.configurations.training_batch.how_it_works' | translate }}
    </p>
    <div class="steps-row">
      <div class="step-item">
        <div class="step-number">1</div>
        <div class="step-content">
          <p class="font-medium m-0 mb-1">{{ 'layout.configurations.training_batch.steps.upload.title' | translate }}</p>
          <p class="text-sm text-color-secondary m-0">
            {{ 'layout.configurations.training_batch.steps.upload.desc_prefix' | translate }}
            <!-- i18n-ignore: storage paths / file extensions -->
            <code>.xlsx</code>
            {{ 'layout.configurations.training_batch.steps.upload.desc_middle' | translate }}
            <!-- i18n-ignore: storage paths / file extensions -->
            <code>training-import/pending/</code>
            {{ 'layout.configurations.training_batch.steps.upload.desc_suffix' | translate }}
          </p>
        </div>
      </div>
      <div class="step-arrow"><i class="pi pi-arrow-right"></i></div>
      <div class="step-item">
        <div class="step-number">2</div>
        <div class="step-content">
          <p class="font-medium m-0 mb-1">{{ 'layout.configurations.training_batch.steps.process.title' | translate }}</p>
          <p class="text-sm text-color-secondary m-0">{{ 'layout.configurations.training_batch.steps.process.desc' | translate }}</p>
        </div>
      </div>
      <div class="step-arrow"><i class="pi pi-arrow-right"></i></div>
      <div class="step-item">
        <div class="step-number">3</div>
        <div class="step-content">
          <p class="font-medium m-0 mb-1">{{ 'layout.configurations.training_batch.steps.archive.title' | translate }}</p>
          <p class="text-sm text-color-secondary m-0">
            {{ 'layout.configurations.training_batch.steps.archive.desc_prefix' | translate }}
            <!-- i18n-ignore: storage paths / file extensions -->
            <code>archive/</code>
            {{ 'layout.configurations.training_batch.steps.archive.desc_middle' | translate }}
            <!-- i18n-ignore: storage paths / file extensions -->
            <code>archive/failed/</code>.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="canTriggerContractNotification" class="batch-card p-4 border-1 border-300 border-round surface-card mt-4">
    <div class="flex align-items-start gap-3">
      <div class="batch-icon-wrap">
        <i class="pi pi-bell batch-icon"></i>
      </div>
      <div class="flex-1">
        <p class="text-lg font-semibold m-0 mb-2">{{ 'layout.configurations.training_batch.lifecycle_notifications.title' | translate }}</p>
        <p class="text-sm text-color-secondary m-0">
          {{ 'layout.configurations.training_batch.lifecycle_notifications.description' | translate }}
        </p>
      </div>
    </div>
    <div class="batch-action-bar mt-3 pt-3 border-top-1 border-200">
      <div class="flex align-items-center justify-content-end">
        <p-button
          icon="pi pi-envelope"
          [label]="'layout.configurations.training_batch.lifecycle_notifications.btn_run' | translate"
          [loading]="contractNotificationLoading"
          [disabled]="contractNotificationLoading"
          (onClick)="triggerLifecycleNotifications()"
          styleClass="p-button-outlined">
        </p-button>
      </div>
    </div>
  </div>
</div>
